export const ITEM_TYPE_DEFAULT = 0;
export const ITEM_TYPE_SIMPLE = 1;
export const ITEM_TYPE_DROPDOWN = 2;

export default class DraggableItemController {
  static $inject = ['$element'];

  value: string;
  selected: boolean;
  additionalText: string;
  onSelect: (args: { $id: string }) => void;
  onTrigger: (args: { $id: string }) => void;
  onDragStart: (args: { $evt: DragEvent; $id: string }) => void;
  onDragEnd: (args: { $evt: DragEvent; $id: string }) => void;
  type = ITEM_TYPE_DEFAULT;
  contextId: string;

  LABEL_SELECTOR = '.pill-label';

  constructor(private $element: angular.IRootElementService) {}

  /**
   * @todo add class 'is-grabbing' to the entire side column container on drag
   */
  $postLink = () => {
    const $pillElem = this.$element.find(this.LABEL_SELECTOR);
    const pillElem = $pillElem.get(0);

    $pillElem.attr('draggable', 'true');
    $pillElem.on('mousedown', (evt) => this.handleMouseDown(evt));

    // using add event listener because jQuery requires monkey
    // patching to support the dataTransfer attribute on drag events
    // read more about this here
    // @see https://bocoup.com/weblog/using-datatransfer-with-jquery-events
    // read more about how jQuery normalizes events here
    // @see http://api.jquery.com/category/events/event-object/
    pillElem.addEventListener('dragstart', (evt) => this.handleDragStart(evt));
    pillElem.addEventListener('dragend', (evt) => this.handleDragEnd(evt));
  };

  $onDestroy = () => {
    const $pillElem = this.$element.find(this.LABEL_SELECTOR);
    const pillElem = $pillElem.get(0);

    $pillElem.off('mousedown');
    pillElem.parentNode.replaceChild(pillElem.cloneNode(true), pillElem);
  };

  getId() {
    return this.value;
  }

  selectLabel() {
    this.onSelect({ $id: this.getId() });
  }

  trigger() {
    if (this.onTrigger) {
      this.onTrigger({ $id: this.getId() });
    }
  }

  getClassState() {
    return {
      'is-selected': this.selected,
      'is-type-dropdown': this.isTypeDropdown(),
      'is-type-simple': this.isTypeSimple(),
      'is-type-default': this.isTypeDefault(),
      'has-additional-text': this.additionalText,
    };
  }

  isTypeSimple() {
    return this.type == ITEM_TYPE_SIMPLE;
  }

  isTypeDropdown() {
    return this.type == ITEM_TYPE_DROPDOWN && !!this.onTrigger;
  }

  isTypeDefault() {
    return this.type == ITEM_TYPE_DEFAULT;
  }

  handleMouseDown(evt) {
    this.selectLabel();
  }

  handleDragStart(evt) {
    const $id = this.getId();
    const { value, contextId } = this;
    const serializedData = JSON.stringify({ value, contextId });

    if (this.onDragStart) {
      this.onDragStart({ $evt: evt, $id });
    }
    evt.dataTransfer.setData('data', serializedData);
    this.selectLabel();
  }

  handleDragEnd(evt) {
    const $id = this.getId();

    if (this.onDragEnd) {
      this.onDragEnd({ $evt: evt, $id });
    }
  }
}
